export function requiredField<T>(
  value: T | undefined | null,
  fieldName: string,
): T {
  if (value === undefined || value === null) {
    throw new Error(`${fieldName} is required`);
  }
  return value;
}
